import React from 'react';
import { isStringNotEmpty } from '../../utils/objectUtils';
import moment from 'moment-timezone';

// Constant used to identify messages authored by the AI support assistant
const AI_AUTHOR_ID = 'SUPPORT_AI';

/**
 * SupportChatMessage - Individual chat message bubble
 *
 * Renders differently based on whether the message is from the AI persona,
 * a staff member, or the customer.
 */
const SupportChatMessage = ({ message }) => {

	//#region Message Classification

	// Determine if the message is from AI or the user to apply correct styling
	const isAi = message.authorId === AI_AUTHOR_ID;
	const isUser = !isAi;
	//#endregion
	//#region formatTimeAndAuthorName

	/**
	 * Formats a Firestore timestamp or Date into a human-readable time string (e.g., "2:30 PM")
	 */
	const formatTime = (sentAt) => {
		if (!sentAt) return '';
		const date = sentAt?.toDate ? sentAt.toDate() : new Date(sentAt);
		return moment(date).format('h:mm A');
	};

	// Display "Ava" for AI messages, "You" for user messages, or a custom author name if present
	const authorName = isAi
		? (message.metadata?.authorName || 'Ava')
		: (message.metadata?.authorName || 'You');

	//#endregion
	//#region returnJSX

	return (
		<div className={`support-message ${isUser ? 'support-message-user' : 'support-message-ai'}`}>
			{/* Avatar - only shown for AI/staff messages (left side) */}
			{!isUser && (
				<div className="support-message-avatar">
					<i className="fas fa-headset"></i>
				</div>
			)}
			<div className="support-message-content">
				{/* Message bubble with the actual text content */}
				<div className="support-message-bubble">
					{isStringNotEmpty(message.content?.raw) && (
						<p className="mb-0">{message.content.raw}</p>
					)}
				</div>
				{/* Metadata row: author name and timestamp */}
				<div className="support-message-meta">
					<span className="support-message-author">{authorName}</span>
					<span className="support-message-time">{formatTime(message.sentAt)}</span>
				</div>
			</div>
		</div>
	);
	//#endregion
};

export default SupportChatMessage;
